import { Invoice, InvoiceQueryParams } from '@ravago/shared/page-data/models/elements';
import { PaginatedResponse } from '@ravago/shared/page-data/models/elements/paginated-response.model';
import { DateUtils } from '@ravago/shared/page-data/utils/date';

import { BillingType } from '../models/billing-type.model';

import { Action, InvoiceAction } from './invoice.actions';

export interface InvoiceState {
   areClosedInvoicesLoading: boolean;
   closedInvoices: { [page: number]: PaginatedResponse<Invoice[]> } | null;
   closedInvoicesQueryParams: InvoiceQueryParams;
   selectedBillingType: BillingType;
}

export const initialInvoiceState: InvoiceState = {
   areClosedInvoicesLoading: false,
   closedInvoices: null,
   closedInvoicesQueryParams: {
      page: 1,
      isOpen: false,
      size: 20,
      dateFrom: DateUtils.getStartOfYearFromCurrentInUtc(2).toString()
   },
   selectedBillingType: BillingType.OPEN
};

export const InvoiceReducer = (state: InvoiceState, action: Action): InvoiceState => {
   switch (action.type) {
      case InvoiceAction.CLOSED_INVOICES_NOT_FOUND:
         return { ...state, closedInvoices: null, areClosedInvoicesLoading: false };
      case InvoiceAction.SET_BILLING_TYPE:
         return {
            ...state,
            selectedBillingType: action.payload,
            areClosedInvoicesLoading: !state.closedInvoices && action.payload === BillingType.CLOSED
         };
      case InvoiceAction.SET_CLOSED_INVOICES:
         return {
            ...state,
            closedInvoices: {
               ...state.closedInvoices,
               [action.payload.number]: action.payload
            },
            areClosedInvoicesLoading: false
         };
      case InvoiceAction.SET_CLOSED_INVOICES_QUERY_PARAMS:
         return {
            ...state,
            closedInvoicesQueryParams: { ...state.closedInvoicesQueryParams, ...action.payload },
            areClosedInvoicesLoading: !state.closedInvoices?.[action.payload.page]
         };
      default:
         return state;
   }
};
